export namespace APIresponse {
  export class Config {
    apiDomain?: string;
    merchantPortalDomain?: string;
    ssoDomain?: string;
    ssoLogoutApi?: string;
    xpressWebsiteLink?: XpressWebsiteLink;
  }
  export class KycType {
    kycName?: string[];
  }
  export class API {
    responseCode?: string;
    responseMessage?: string;
    data?: any;
    success?: boolean;
    pending?: boolean;
    requestId?: string;
    transactionDateTime?: any;
  }

  export class XpressWebsiteLink {
    About?: string;
    ContactUs?: string;
  }

  export class Permission {
    id?: number;
    name?: string;
    checked?: boolean;
  }

  export class ExcludedBiller {
    id?: number;
    name?: string;
    checked?: boolean;
  }

  export interface Role {
    id?: number;
    name: string;
    createdBy?: string;
    creationDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    key?: any;
    permissions: Permission[];
    permission?: any;
  }

  export interface MerchantUser {
    email: string;
    enabled: boolean;
    role: Role;
    id: number;
    merchant: MerchantProfile;
    roleName: any;
    status: any;
    key: any;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    token?: any;
    registeredUser: boolean;
    createdBy?: string;
    creationDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
  }

  export class ValidateUser {
    email?: string;
    password?: any;
    enabled?: boolean;
    role?: Role;
    id?: number;
    merchant?: MerchantProfile;
    merchantKYC?: MerchantKYC;
    firstName?: string;
    kycTierDTO?: KYCTiers;
    pendingKycTierDTO?: PendingKycTierDTO;
    lastName?: string;
    phoneNumber?: string;
    token?: string;
    registeredUser?: boolean;
  }

  export interface CategoryDTO {
    deleted: boolean;
    createdBy?: any;
    createdDate: string;
    modifiedBy?: any;
    modifiedDate: string;
    id: number;
    name: string;
    key?: any;
  }

  export interface MerchantBiller {
    deleted: boolean;
    createdBy?: any;
    createdDate: string;
    modifiedBy?: any;
    modifiedDate: string;
    id: number;
    name: string;
    billerCode: string;
    description: string;
    categoryDTOS: CategoryDTO[];
    categories: any;
    imageUrl: string;
    ewalletAcct?: any;
    key: any;
    allBillerDTO: AllBillerResponse[];
  }

  export class AllBillerResponse {
    id?: number;
    name?: string;
    categoryDTOS?: CategoryDTO[];
  }

  export class MerchantBillers {
    deleted?: boolean;
    createdBy?: string;
    createdDate?: string;
    modifiedBy?: string;
    modifiedDate?: string;
    id?: number;
    merchantId?: string;
    billers?: AllBillerResponse;
    checked?: boolean;
  }
  export interface MerchantProducts {
    deleted: boolean;
    createdBy?: any;
    createdDate: string;
    modifiedBy?: any;
    modifiedDate: string;
    id: number;
    name: string;
    productCode: string;
    lookUp: boolean;
    fixedAmount: boolean;
    amount: number;
    minimumAmount: number;
    maximumAmount: number;
    imageUrl: string;
    billerName: string;
    categoryDTO: CategoryDTO;
    category?: any;
    key: any;
    uniqueCode?: string;
  }

  export interface CommissionDTO {
    deleted: boolean;
    createdBy?: any;
    createdDate: string;
    modifiedBy?: any;
    modifiedDate: string;
    id: number;
    name: string;
    commissionModel: string;
    value: number;
    maxCap: number;
    minCap: number;
    convenienceFee: number;
    approvedBy?: any;
    approved: boolean;
  }

  export interface MerchantCommission {
    deleted: boolean;
    createdBy?: any;
    createdDate: string;
    modifiedBy?: any;
    modifiedDate: string;
    id: number;
    merchantId: string;
    billerId: number;
    billerName: string;
    commissionDTO: CommissionDTO;
    commissionModel: any;
    minCap: any;
    maxCap: any;
    convenienceFee: any;
    commissions?: any;
    key: any;
    productDTO: MerchantProducts[];
  }

  export interface TransactionDTO {
    id: number;
    amount: number;
    categoryName: string;
    productName: string;
    productCode: string;
    billerName: string;
    billerCode: string;
    requestId: string;
    referenceNumber: string;
    walletReferenceNumber: string;
    billerReferenceNumber: string;
    billerStatusCode: string;
    billerStatusMessage: string;
    transactionDate: string;
    merchantId: string;
    key: any;
  }

  export interface Top10Transactions {
    hasNextRecord: boolean;
    totalCount: number;
    transactionDTOS: TransactionDTO[];
  }

  export interface Balances {
    walletBalance: number;
    commissionBalance: number;
    value: any;
  }

  export interface PieType {
    name: string;
    value: number;
  }

  export interface Statistics {
    pendingTransaction?: number;
    pendingTransactionCount?: number;
    totalTransaction: number;
    totalTransactionCount: number;
    successfulTransaction: number;
    successfulTransactionCount: number;
    failedTransaction: number;
    failedTransactionCount: number;
    categoriesReport: PieType[];
    billersReport: PieType[];
    productsReport: PieType[];
    day: any;
  }

  export interface Settings {
    publicKey: string;
    privateKey: string;
    merchantUser: MerchantUser[];
  }

  export interface WalletAlertResponse {
    active: boolean;
    amount: number;
    recipientEmails: string[];
    walletNumber: string;
    lastUpdated: string;
    updatedBy: string;
    lastNotifiedDay: string;
    key: any;
  }

  export interface WalletTransactionDTO {
    id: number;
    amount: number;
    transactionRef: string;
    balanceAfter: number;
    balanceBefore: number;
    walletNumber: string;
    transactionType: string;
    description: string;
    transactionDate: string;
    key: any;
  }
  export interface WalletTransaction {
    hasNextRecord: boolean;
    totalCount: number;
    key: any;
    walletTransactionDTOS: WalletTransactionDTO[];
  }

  export interface CommissionTransactionDTO {
    id: number;
    amount: number;
    balanceBefore: number;
    balanceAfter: number;
    walletTransaction: WalletTransactionDTO;
    walletTrans: WalletTransactionDTO;
    walletNumber: string;
    transactionDate: string;
    merchantCommission: string;
    merchantCommissionType: string;
    key: any;
  }

  export class WalletCommission {
    hasNextRecord?: boolean;
    totalCount?: number;
    walletTrans?: any;
    key?: any;
    commissionTransactionDTOS?: CommissionTransactionDTO[];
  }

  export interface Report {
    id: number;
    amount: number;
    categoryName: string;
    productName: string;
    productCode: string;
    billerName: string;
    billerCode: string;
    requestId: string;
    referenceNumber: string;
    walletReferenceNumber: string;
    billerReferenceNumber: string;
    billerStatusCode: string;
    billerStatusMessage: string;
    transactionDate: string;
    merchantId: string;
    key: any;
    billerDTOS: MerchantBiller[];
    productDTOS: MerchantProducts[];
  }

  export interface CommissionTransfer {
    transactionRef: string;
    balance: number;
  }

  export class AuditLog {
    id?: number;
    action?: string;
    actionName?: string;
    performedBy?: string;
    merchantId?: any;
    date?: string;
    key?: any;
  }

  export class KycRequirement {
    id?: number;
    name?: string;
  }

  export class PendingKycTierDTO {
    createdBy?: string;
    creationDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    id?: number;
    name?: string;
    dailyTransactionLimit?: number;
    singleTransactionLimit?: number;
    webAccess?: string;
    apiAccess?: string;
    kycRequirements?: KycRequirement[];
  }

  export class KYCTiers {
    createdBy?: string;
    creationDate?: string;
    lastModifiedBy?: any;
    lastModifiedDate?: any;
    id?: number;
    name?: string;
    dailyTransactionLimit?: number;
    singleTransactionLimit?: number;
    webAccess?: string;
    apiAccess?: string;
    kycRequirements?: KycRequirement[];
  }

  export class MerchantKYC {
    id?: number;
    fullName?: any;
    phoneNumber?: any;
    emailAddress?: any;
    dateOfBirth?: any;
    placeOfBirth?: any;
    gender?: any;
    directorBvn?: any;
    homeAddress?: any;
    bvn?: any;
    directorName?: any;
    utilityBill?: any;
    governmentIssuedIdCard?: any;
    directorValidIdCard?: any;
    certificateOfIncorporation?: any;
    cac2AndCac7?: any;
    memart?: any;
    boardResolutionApproval?: any;
    gazette?: any;
    kycStatus?: string;
    declineReason?: any;
    kycUploadComplete?: boolean;
  }

  export class MerchantProfile {
    id?: number;
    merchantId?: string;
    publicKey?: string;
    privateKey?: string;
    name?: string;
    email?: string;
    address?: string;
    rcNo?: string;
    phoneNumber?: any;
    ownerFirstName?: any;
    ownerLastName?: any;
    walletAccountNo?: string;
    virtualAccountNo?: string;
    ninePSBankVirtualAccountNumber?: string;
    disabled?: boolean;
    webDisabled?: boolean;
    kycTierDTO?: KYCTiers;
    merchantKYC?: MerchantKYC;
  }

  export class TransactionCategory {
    name?: string;
    id?: number;
  }

  export class TransactionBiller {
    id?: number;
    name?: string;
    billerCode?: string;
    description?: string;
    categoryDTOS?: TransactionCategory[];
    imageUrl?: string;
    uniqueCode?: string;
    lookUp?: boolean;
    fixedAmount?: boolean;
    amount?: number;
    minimumAmount?: any;
    maximumAmount?: any;
    billerName?: string;
    categoryDTO?: TransactionCategory;
  }

  export class TransactionProduct {
    name?: string;
    uniqueCode?: string;
    lookUp?: boolean;
    fixedAmount?: boolean;
    amount?: number;
    minimumAmount?: any;
    maximumAmount?: any;
    imageUrl?: string;
    billerName?: string;
    categoryDTO?: TransactionCategory;
  }

  export class LookUpResponse {
    data?: Data;
    trnsactionData?: string;
    firstName?: string;
    lastName?: string;
    username?: string;
    surname?: string;
    middleName?: string
    profileType?: string;
    profileCode?: string;
    phoneNumber?: string;
    accountNumber?: string;
    accountType?: string;
    amount?: number;
    uniqueCode: any;
    name?: string;
    address?: string;
    arrears?: string;
    tariffName?: string;
    rate?: string;
    minimumVending?: string;
    email?: string;
    noOfCandidate?: any;
    noOfMonth?: any;
  }
  export class Data {
    name?: string;
    address?: string;
    phoneNumber?: string;
    arrears?: string;
    tariffName?: string;
    rate?: string;
    minimumVending?: string;
    accountType?: string;
    accountNumber?: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    customerId?: string;
    username?: string;
    amount?: any;
    surname?: string;
    middleName?: string
    profileType?: string;
    profileCode?: string;
  }
  
  export class AllBulkAirtime {
    id?: number
    fileName?: string
    totalAmount?: number
    createdBy?: string
    createdDate?: string
    key?: any;
  }
  

  export class BulkAirtime {
    id?: number;
    bulkItemStatus?: string;
    billerName?: string;
    phoneNumber?: string;
    amount?: number;
    requestId?: string;
    referenceId?: any;
    responseCode?: string;
    responseMessage?: string;
    transactionDateTime?: string;
    key?: any;
  }
  
  export class MerchantSettlements {
    key?: any;
    id?: number
    transactionDate?: string
    requestId?: string
    merchantId?: string
    serviceProvider?: string
    billerName?: string
    billerCode?: string
    productName?: string
    productCode?: any
    referenceNumber?: string
    productAmount?: number
    billerStatusCode?: string
    billerStatusMessage?: string
    billerReferenceNumber?: string
    transactionAmount?: number
    walletReferenceNumber?: string
    walletReversalReferenceNumber?: any
    merchantCommissionAmount?: number
    merchantCommission?: number
    merchantCommissionType?: string
    convenienceFee?: number
    performedBy?: string
    mdCustomer?: boolean
    categoryName?: string
    transactionType?: string
    channel?: string
  }
  
}
